import React from "react";
import { useLocation, Link } from "react-router-dom";

const Footer = ({ footerRef }) => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  return (
    <>
      {/* --- New multi-column footer section --- */}
      {/* Place after the existing footer */}

      {/*
        Products: ZYPHER AI, FOZZIL Intelligence, NISTIA, AWM, Pricing
        Company: About, Contact, Ethics & Compliance, Terms of Use, Privacy Policy
        Resources: Documentation, Security, Legal, Status (add as needed)
        Try Fozzil On: Web, iOS, Android, etc. (example links)
      */}

      <footer
        ref={footerRef}
        className="w-full bg-black pt-16 pb-8 relative z-10"
      >
        <div className="max-w-7xl mx-auto px-4 pb-[350px] sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-7 gap-10 justify-center items-start text-left">
            <div>
              <h4 className="text-lg tracking-widest text-gray-400 mb-4 uppercase text-left whitespace-nowrap">
                Try FOZZIL On
              </h4>
              <ul className="space-y-2 text-left">
                <li>
                  <a
                    href="https://intelligence.fozzil.in"
                    className="text-white hover:underline text-lg whitespace-nowrap"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Web
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg tracking-widest text-gray-400 mb-4 uppercase whitespace-nowrap">
                Products
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/zypherai"
                    className="text-white  hover:underline text-lg"
                  >
                    ZYPHER AI
                  </Link>
                </li>
                <li>
                  <Link
                    to="/fozzil-intelligence"
                    className="text-white  hover:underline text-lg whitespace-nowrap"
                  >
                    FOZZIL Intelligence
                  </Link>
                </li>
                <li>
                  <Link
                    to="/nistia"
                    className="text-white  hover:underline text-lg"
                  >
                    N.I.S.T.I.A
                  </Link>
                </li>
                <li>
                  <Link
                    to="/pricing"
                    className="text-white  hover:underline text-lg"
                  >
                    Pricing
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg tracking-widest text-gray-400 mb-4 uppercase">
                Research
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/awm"
                    className="text-white hover:underline text-lg"
                  >
                    AWM
                  </Link>
                </li>
                {/* Add more research links here if needed */}
              </ul>
            </div>
            <div>
              <h4 className="text-lg tracking-widest text-gray-400 mb-4 uppercase">
                Company
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-white  hover:underline text-lg"
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-white  hover:underline text-lg"
                  >
                    Contact us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/brand"
                    className="text-white  hover:underline text-lg"
                  >
                    Brand
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg tracking-widest text-gray-400 mb-4 uppercase">
                Resources
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/terms-of-use"
                    className="text-white  hover:underline text-lg"
                  >
                    Terms of Use
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy-policy"
                    className="text-white  hover:underline text-lg"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/legal"
                    className="text-white  hover:underline text-lg"
                  >
                    Legal
                  </Link>
                </li>

                <li>
                  <Link
                    to="/ethics-compliance"
                    className="text-white  hover:underline text-lg whitespace-nowrap"
                  >
                    Ethics & Compliance
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cancellation-and-refund"
                    className="text-white  hover:underline text-lg whitespace-nowrap"
                  >
                    Cancellation and Refund
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg tracking-widest text-gray-400 mb-4 uppercase text-left">
                Support
              </h4>
              <ul className="space-y-2 text-left">
                <li>
                  <Link
                    to="/help-center"
                    className="text-white  hover:underline text-lg"
                  >
                    Help Centre
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg tracking-widest text-gray-400 mb-4 uppercase text-left">
                Safety
              </h4>
              <ul className="space-y-2 text-left">
                <li>
                  <Link
                    to="/security-and-privacy"
                    className="text-white hover:underline text-lg whitespace-nowrap"
                  >
                    Security and Privacy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="absolute left-0 right-0 top-1/2 h-1/2 pointer-events-none select-none"
          style={{
            background: "linear-gradient(0deg, #0092ed 0%, transparent 100%)",
            opacity: 0.18,
          }}
        />
      </footer>
      <footer className="w-screen bg-[#001929] flex justify-between items-center px-[4vw] py-2 min-h-[48px] box-border md:flex-row md:gap-0 md:px-[4vw] sm:flex-col sm:gap-2 sm:px-[2vw]">
        <div className="font-secondary text-lg text-[#bfc5c5] font-bold tracking-wide text-center w-full md:w-auto">
          <span>FOZZIL &copy; 2025</span>
        </div>
        <div className="flex items-center gap-2 sm:gap-1 justify-center w-full md:w-auto">
          <a
            href="https://www.facebook.com/fozzilai/"
            className="flex items-center justify-center w-8 h-8 rounded-full bg-none transition-colors duration-200 hover:bg-neutral-900"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="#fff" />
              <path
                d="M20.5 16H17V25H14V16H12V13.5H14V12.25C14 10.1789 15.1789 9 17.25 9H20V11.5H18.5C17.9477 11.5 17.5 11.9477 17.5 12.5V13.5H20.5V16Z"
                fill="#111"
              />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/fozzilai/"
            className="flex items-center justify-center w-8 h-8 rounded-full bg-none transition-colors duration-200 hover:bg-neutral-900"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="#fff" />
              <g>
                <circle cx="16" cy="16" r="6" stroke="#111" strokeWidth="2" />
                <circle cx="22.5" cy="9.5" r="1.5" fill="#111" />
                <rect
                  x="11"
                  y="11"
                  width="10"
                  height="10"
                  rx="5"
                  stroke="#111"
                  strokeWidth="2"
                />
              </g>
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/company/fozzilai"
            className="flex items-center justify-center w-8 h-8 rounded-full bg-none transition-colors duration-200 hover:bg-neutral-900"
            aria-label="LinkedIn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="#fff" />
              <g>
                <rect x="11" y="13" width="2.5" height="7" fill="#111" />
                <rect x="18.5" y="16" width="2.5" height="4" fill="#111" />
                <circle cx="12.25" cy="11.25" r="1.25" fill="#111" />
                <rect x="14.5" y="16" width="2.5" height="4" fill="#111" />
              </g>
            </svg>
          </a>
          <a
            href="https://x.com/fozzilai"
            className="flex items-center justify-center w-8 h-8 rounded-full bg-none transition-colors duration-200 hover:bg-neutral-900"
            aria-label="X"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="#fff" />
              <path
                d="M12 12L20 20M20 12L12 20"
                stroke="#111"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </a>
          <a
            href="https://www.youtube.com/@FozzilAI"
            className="flex items-center justify-center w-8 h-8 rounded-full bg-none transition-colors duration-200 hover:bg-neutral-900"
            aria-label="YouTube"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="#fff" />
              <path d="M13 12L21 16L13 20V12Z" fill="#111" />
            </svg>
          </a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
